"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
function TextTab(props) {
    const { text, selected } = props;
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({}, props, { "$selected": selected, children: text.toUpperCase() })));
}
const Container = styled_components_1.default.div `
  display: flex;
  padding: 0px 16px 8px 16px;
  color: ${props => props.theme.grasshopper.text.white};
  cursor: pointer;

  ${props => props.$selected &&
    `
    border-bottom: solid 4px ${props.theme.grasshopper.borders.white};
  `}
`;
exports.default = TextTab;
